import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SeigaihaStrip } from "./JapaneseMotifs";

export function TransitionBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <div ref={ref} className="relative h-[300px] sm:h-[400px] overflow-hidden" data-testid="transition-band" aria-hidden="true">
      <motion.img
        src="/img/transition.jpg"
        alt=""
        style={{ y }}
        className="absolute inset-0 w-full h-[124%] object-cover object-center"
      />
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-deepsea to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-ice to-transparent" />
      <SeigaihaStrip className="absolute bottom-0 inset-x-0 w-full h-9 opacity-30" />
    </div>
  );
}
